import Swiper, { Navigation, Pagination } from 'swiper';

document.addEventListener( 'DOMContentLoaded', () => {
	const sections = document.querySelectorAll('.card-slider-section');

	sections.forEach((section) => {
		const sliderButtonPrev = section.querySelector('.swiper-button-prev');
		const sliderButtonNext = section.querySelector('.swiper-button-next');

		const swiper = new Swiper(section.querySelector('.swiper'), {
			modules: [Navigation, Pagination],
			loop: false,

			slidesPerView: 1,
			spaceBetween: 30,
			watchSlidesProgress: true,

			breakpoints: {
				576: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},

			pagination: {
				direction: 'horizontal',
				el: section.querySelector('.swiper-pagination'),
				type: 'bullets',
				clickable: true,
			},

			navigation: {
				nextEl: sliderButtonNext,
				prevEl: sliderButtonPrev,
			},
		});

		document.addEventListener('hero-destroy', () => {
			swiper.update();
		})
	})
} )